import Auth from "./auth/reducer";
import App from "./app/reducer";
import LanguageSwitcher from "./languageSwitcher/reducer";
import ThemeSwitcher from "./themeSwitcher/reducer";

export default {
  App,
  Auth,
  LanguageSwitcher,
  ThemeSwitcher,
};
